<template>
  <div class="txtwav bounce">
    <div class="wx">
      <img :src="wcIcon" class="wx-icon" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    wcIcon: String
  }
};
</script>

<style lang="scss" scoped>
.wx {
  z-index: 1000;
  position: fixed;
  bottom: 100px;
  right: 9%;
  width: 253px;
  height: 132px;
  background-image: url("../assets/wx-icon.png");
  background-size: 100% 100%;
  cursor: pointer;
  @media screen and (max-width: 1700px) {
    right: 2%;
  }
  &-icon {
    width: 100px;
    height: 100px;
    margin: 16px;
  }
}
</style>